import React from 'react';

import {TaskSchemaNodeRendererProps} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/processFlowchartConfigEditorConstants';
import {
  TaskSchemaNodeData,
  TaskSchemaNodeRowData,
} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/processFlowchartConfigEditorNodeTypes';
import BenchlingNode from 'ui-library/reactflow/nodes/BenchlingNode/BenchlingNode';

export default function TaskSchemaNodeRenderer(props: TaskSchemaNodeRendererProps): JSX.Element {
  return <BenchlingNode<TaskSchemaNodeRowData, TaskSchemaNodeData> {...props} />;
}
